import { render, staticRenderFns } from "./PurchaseContent.vue?vue&type=template&id=b859c2bc&lang=pug"
import script from "./PurchaseContent.vue?vue&type=script&lang=js"
export * from "./PurchaseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports